<template>
  <CustomModal
    title="Delete API Key"
    :visible="visible"
    @update:visible="updateVisible"
    :width="'32vw'"
  >
    <p>
      Are you sure you want to delete this API key? This action cannot be
      undone.
    </p>
    <template #footer>
      <div class="flex flex-row items-center gap-2">
        <a-button class="secondary_medium" @click="updateVisible(false)"
          >Cancel</a-button
        >
        <a-button
          class="primary_medium danger"
          @click="toDeleteAPIKey"
          :loading="isDeleting"
          >{{ isDeleting ? "Deleting.." : "Delete API Key" }}</a-button
        >
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";
import CustomModal from "@/src/components/CustomModal.vue";
import DashboardService from "@/src/api/DashboardService.js";

const props = defineProps({
  visible: Boolean,
  keyToDelete: Object,
});

const emit = defineEmits(["update:visible", "key-deleted"]);

const isDeleting = ref(false);

const updateVisible = (value) => {
  emit("update:visible", value);
};

const toDeleteAPIKey = async () => {
  try {
    if (!props.keyToDelete?.id) {
      message.error("Invalid API key selected");
      return;
    }

    isDeleting.value = true;

    const response = await DashboardService.deleteAPIKey(props.keyToDelete.id);

    if (response?.success) {
      emit("key-deleted");
      message.success("API Key successfully deleted!");
      updateVisible(false);
    }
  } catch (error) {
    message.error("An error occurred while deleting API Key");
    console.error("An error occurred while deleting API Key: ", error);
  } finally {
    isDeleting.value = false;
  }
};
</script>
